export const ASTERIO_BID = {
  API_URL: import.meta.env.VITE_ASTERIO_BID_API,
  CURRENCY: 'USD',
  WRAPPER_ELEMENT_ID: 'asterio-bid-wrapper',
} as const
